import React from 'react';
import { Form, Checkbox, DatePicker, Input, Select, Divider } from 'antd';

import FieldUpload from './FieldUpload';

class DictationsAndReportInformation extends React.Component {
  render() {
    return (
      <Form name="dictations-and-report-information">
        <div className="fluid-field checkbox-field">
          <Checkbox>Dictation Received</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC 5<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Dictation Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Dictations"
        />
        <Form.Item
          className="fluid-field"
          label="OneDrive links to Dictation Files"
        >
          <Input.TextArea rows={6} />
        </Form.Item>
        <Form.Item className="fluid-field" label="Comments">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Dictation Sent To Typist</Checkbox>
        </div>
        <Form.Item label="Typist" required>
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Dictation Instruction"
        />
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Report Templates"
        />

        <div className="fluid-field checkbox-field">
          <Checkbox>Send Files to Typist</Checkbox>
        </div>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Typed Report"
        />

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Report Draft Sent to Specialist</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC 6<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Report Draft Received Date">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Report Draft Sent Date">
          <DatePicker size="large" />
        </Form.Item>

        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Report Draft"
        />
        <div className="fluid-field checkbox-field">
          <Checkbox>Send Report Draft as Attachment</Checkbox>
        </div>
        <Form.Item className="fluid-field" label="Comments">
          <Input.TextArea rows={6} />
        </Form.Item>

        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Corrected Report Returned from Specialist</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC 7<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Corrected Report Returned Date">
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Corrected Report"
        />
        <Divider className="fluid-field" />
        <div className="fluid-field checkbox-field">
          <Checkbox>Report Sent to CMs</Checkbox>
        </div>
        <Form.Item
          label={
            <React.Fragment>
              PIC 8<button className="field-actions">Recent changes</button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Date of Report Sent to CMs">
          <DatePicker size="large" />
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Final Report"
        />
        <Form.Item className="fluid-field" label="Send Final Report to">
          <Checkbox.Group>
            <Checkbox>Booking Solicitor</Checkbox>
            <Checkbox>Booking CM</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <FieldUpload
          uploadLoading={false}
          attachments={null}
          label="Attached Amended Report"
        />
        <Form.Item className="fluid-field" label="Send Final Report to">
          <Checkbox.Group>
            <Checkbox>Booking Solicitor</Checkbox>
            <Checkbox>Booking CM</Checkbox>
          </Checkbox.Group>
        </Form.Item>
        <Form.Item
          className="fluid-field"
          label="Comments"
          style={{ marginBottom: 0 }}
        >
          <Input.TextArea rows={6} />
        </Form.Item>
      </Form>
    );
  }
}

export default DictationsAndReportInformation;
